import React, { useState, useEffect } from "react";
import "./Treasury.scss";
import TreasuryTabs from "../../components/TreasuryTabs/TreasuryTabs";
import { useSelector } from "react-redux";
import { searchAppsByLabel } from "../../util/utilfunctions/utilFunctions";

function Treasury() {
  const [securityPermissions, setSecurityPermissions] = useState([]);

  const securityAccess = useSelector((state) => state.login.securityAccess);

  useEffect(() => {
    const securityUser = searchAppsByLabel("treasury", securityAccess);
    console.log(securityUser);

    if (securityUser.length) {
      setSecurityPermissions(securityUser[0]);
    }
  }, []);
  return (
    <div className="page-container">
      <div className="header-container">
        <div className="page-title">Treasury</div>
      </div>
      <div className="treasury-tabs">
        <TreasuryTabs securityPermissions={securityPermissions} />
      </div>
    </div>
  );
}

export default Treasury;
